(ns manage.campaign.modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [clojure.string :as str]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.campaign :as cq]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.input :refer [input]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal create-campaign :campaign/create
  []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])

        [name set-name] (uix/use-state "")
        {create-campaign :mutate} (use-mutation (cq/create-campaign-mutation {:advertiser-id advertiser-id}))]
    ($ modal-v2
       {:title "Create campaign"
        :footer ($ Stack
                   {:direction "row"
                    :gap 1
                    :sx #js {:padding 0 :alignItems "right"}}
                   ($ Button
                      {:variant "text"
                       :sx #js {:color "text.primary"}
                       :onClick #(rf/dispatch [:modal/close])}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :onClick (fn []
                                  (create-campaign {:name name}
                                                   #js {:onMutate #(rf/dispatch [:loader/open])
                                                        :onSettled #(rf/dispatch [:loader/close])
                                                        :onSuccess #(rf/dispatch [:modal/close])}))
                       :disabled (str/blank? name)}
                      "Create"))}
       ($ Stack {:sx #js {:py 2 :minWidth 480}}
          ($ form-field
             {:label "Name"
              :required? true}
             ($ input
                {:type "text"
                 :data-testid "campaign-name-input"
                 :autoFocus true
                 :placeholder "Type a name..."
                 :value name
                 :onChange #(set-name (-> % .-target .-value))})
             ($ hint "How is your campaign best described?"))))))

(defmodal rename-campaign :campaign/rename
  [{:keys [campaign]}]
  (let [[name set-name] (uix/use-state (get campaign :name ""))
        {patch-campaign :mutate} (use-mutation (cq/patch-campaign-mutation {:campaign-id (:id campaign)}))]
    ($ modal-v2
       {:title "Rename campaign"
        :footer ($ Stack
                   {:direction "row"
                    :gap 1
                    :sx #js {:padding 0 :alignItems "right"}}
                   ($ Button
                      {:variant "text"
                       :sx #js {:color "text.primary"}
                       :onClick #(rf/dispatch [:modal/close])}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :onClick (fn []
                                  (patch-campaign {:name name}
                                                  #js {:onSuccess #(rf/dispatch [:modal/close])}))
                       :disabled (str/blank? name)}
                      "Save"))}
       ($ Stack {:sx #js {:py 2 :minWidth 480}}
          ($ form-field
             {:label "Name"}
             ($ input
                {:type "text"
                 :value name
                 :on-change #(set-name (.. % -target -value))
                 :data-testid "campaign-name-input"}))))))
